<template>
  <TableLayout :permissions="['business:ad:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="标题" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap >
      <ul class="toolbar" v-permissions="['business:ad:create']">
        <li><el-button type="primary" @click="$refs.operaAdWindow.open('新建广告')" icon="el-icon-plus"
            v-permissions="['business:ad:create']">新建</el-button></li>
      </ul>
      <el-table v-loading="isWorking.search" :data="tableData.list" stripe border>
        <el-table-column prop="name" label="标题" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="imgfullurl" label="广告图" min-width="100px" align="center">
          <template slot-scope="{row}">
            <el-image style="width: 80px; height: 60px; margin-right: 5px;" :src="row.imgfullurl" fit="contain"
              :prediv-src-list="[row.imgfullurl]"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="sortnum" label="排序码（升序）" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px" align="center"></el-table-column>


        <!-- <el-table-column prop="creator" label="创建人" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="编辑时间" min-width="100px"></el-table-column>
        <el-table-column prop="editor" label="编辑人" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否已删除 0未删除 1已删除" min-width="100px"></el-table-column>
        <el-table-column prop="type" label="类型 0图文 1外链 2其他" min-width="100px"></el-table-column>
        <el-table-column prop="status" label="状态 0启用 1禁用" min-width="100px"></el-table-column>
        <el-table-column prop="info" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="content" label="内容" min-width="100px"></el-table-column> -->
        <el-table-column v-if="containPermissions(['business:ad:update', 'business:ad:delete'])" label="操作"
          min-width="120" fixed="right" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaAdWindow.open('编辑广告', row)" icon="el-icon-edit"
              v-permissions="['business:ad:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete"
              v-permissions="['business:ad:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination @size-change="handleSizeChange" @current-change="handlePageChange" :pagination="tableData.pagination">
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaAdWindow ref="operaAdWindow" @success="handlePageChange" />
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaAdWindow from '@/components/business/OperaAdWindow'
export default {
  name: 'Ad',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaAdWindow },
  data() {
    return {
      // 搜索
      searchForm: {
        id: '',
        createDate: '',
        creator: '',
        editDate: '',
        editor: '',
        isdeleted: '',
        name: '',
        sortnum: '',
        type: '',
        status: '',
        info: '',
        content: '',
        imgurl: ''
      }
    }
  },
  created() {
    this.config({
      module: '广告信息表',
      api: '/business/ad',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
